import { useMutation } from "@tanstack/react-query";
import { uploadPtaTierExcelApi } from "../../../../api/correspondent/tierApi";
import { useModal } from "../../../../hooks";
import { AxiosError } from "axios";

export const useUploadPtaTierExcel = () => {
  const { handleModal } = useModal();

  const { mutate } = useMutation({
    mutationFn: (data: FormData) => uploadPtaTierExcelApi(data),
    onSuccess: (res) => {
      handleModal({
        isOpen: true,
        contents: "PTA 티어 엑셀 파일을 가져왔습니다.",
        type: "alert",
      });
    },
    onError: (error: AxiosError<{ msg?: string }>) => {
      if (error?.response?.data?.msg) {
        handleModal({
          isOpen: true,
          contents: error?.response?.data?.msg,
          type: "alert",
        });
      }
    },
  });
  return { mutate };
};
